var en = {
    translation: {
        activity: {
            noTransactionsMessage: 'You have no activity within the past 6 months',
            noTransactionsMessageWithMonths: 'You have no activity to view',
            byDateFilterOption: 'Filter by Date',
            allTransactionsFilterOption: 'All Available Transactions',
            recentTransactionsFilterOption: 'Activity Since Last Statement',
            statementEndingFilterOption: 'Statement Ending - {{date}}',
            loadMoreButton: 'Load More',
            dateTableHeader: 'Date',
            descriptionTableHeader: 'Description',
            manageDisputesButton: 'Manage Disputes',
            typeTableHeader: 'Type',
            statusTableHeader: 'Status',
            amountTableHeader: 'Amount',
            transactionTypeAdjustment: 'Adjustment',
            transactionTypeAuthorization: 'Authorization',
            transactionTypeCashAdvance: 'Cash Advance',
            transactionTypeCredit: 'Credit',
            transactionTypeDefault: 'Transaction',
            transactionTypeFee: 'Fee',
            transactionTypeInterest: 'Interest',
            transactionTypeLateFee: 'Late Fee',
            transactionTypePayment: 'Payment',
            transactionTypePurchase: 'Purchase',
            transactionTypeRefund: 'Refund'
        },
        activityDetails: {
            activityDetailHeader: 'Activity Detail',
            amountLabel: 'Amount',
            addressLabel: 'Address',
            canceledLabel: 'Canceled',
            chargedOnDateLabel: 'Charged on Date',
            confirmationNumberLabel: 'Confirmation Number',
            detailsLabel: 'Details',
            purchaseLocationLabel: 'Purchase Location',
            phoneLabel: 'Phone',
            postedDateLabel: 'Posted Date',
            refNumberLabel: 'Reference Number',
            recurringChargeLabel: 'Recurring Charge',
            recurringChargeLabelValue: 'This may be a recurring charge',
            cancelPayment: {
                cancelPaymentButton: 'Cancel Payment',
                cancelPaymentHeading: 'Cancel Payment',
                paymentCanceledHeading: 'Payment Canceled',
                confirmCancelPaymentButton: 'Yes, Cancel Payment',
                closeCancelPaymentButton: 'No, Close',
                scheduledForLabel: 'Scheduled for',
                canceledConfirmHeader: 'Are you sure you want to cancel this payment?',
                canceledCompleteHeader: 'Your payment has been canceled',
                canceledErrorHeader: 'Sorry, something went wrong',
                canceledErrorMessage: 'There was a problem cancelling your payment.\n Please close this page and try again later.'
            }
        },
        common: {
            apiErrorHeading: 'Oops...',
            apiErrorMessage: 'Unfortunately we are unable to process your request at this time.\n Please try again later.',
            apiDataMissingHeading: "We're having trouble retrieving your information",
            apiDataMissingMessage: 'Please try again later.',
            backButton: 'Back',
            closeButton: 'Close',
            canceledStatus: 'Canceled',
            defaultAccountLabel: 'Your Synchrony Account',
            endingInSubHeading: 'Account ending in',
            pendingStatus: 'Pending',
            postedStatus: 'Posted',
            processingStatus: 'Processing',
            rejectedStatus: 'Rejected',
            scheduledStatus: 'Scheduled',
            viewAllActivityButton: 'View All Activity'
        },
        navBar: {
            activityButton: 'Activity',
            promotionsButton: 'Promotions'
        },
        selectPay: {
            availabilityLabel: 'Available now',
            bannerButton: 'Explore More.',
            bannerSubHeading: 'Get more control over managing your expenses with a reduced APR and predictable equal monthly payments.',
            fullSizeBannerSubheading: 'Get more control over managing your expenses with',
            brandHeading: 'Synchrony Select Pay',
            detailsAccordionButton: 'See how it works',
            completeDetailsHeading: 'Synchrony Select Pay Details',
            completeFooterText: 'Please allow up to 2 days for this to reflect on your account. This will not change your payment due date.',
            completeMonthlyPaymentAmountLabel: 'Monthly Payment Amount',
            completeMonthlyPaymentsLabel: 'Number of Monthly Payments',
            completePurchaseDetailsLabel: 'Purchase Details',
            completeHeading: 'Synchrony Select Pay enrollment successful',
            completeTotalPurchaseAmountLabel: 'Total Purchase Amount',
            completeSubHeading: 'A confirmation email has been sent to your email address on file.',
            completeTransactionHeading: 'Transaction(s) Included',
            annualPercentageRateLabel: 'Promo APR',
            estimatedInterestAmountLabel: 'Total Interest',
            estimatedTotalAmountLabel: 'Total Amount',
            errorPromoLimitReachedHeading: "You've reached your Synchrony Select Pay limit of 4",
            errorPromoLimitReachedSubHeading: 'Pay off one of your promo balances to add a new transaction.',
            installmentsSelectOptionsHeading: 'Select the Synchrony Select Pay offer that works for you',
            installmentsReviewHeading: 'Please review your selected Synchrony Select Pay offer',
            installmentsReviewDisclaimerText: "Once accepted, this offer is final and can't be changed.",
            installmentsSelectedRowHeading: 'Transaction selected for Synchrony Select Pay',
            installmentRateLabel: 'APR',
            installmentMonthLabel: 'Month',
            installmentsMonthsLabel: 'months',
            promotionalTermDetailsHeading: 'Promotional Term Details',
            promotionalTermDetailsSubheading: 'By choosing Accept Offer below, you understand and agree that:',
            termDetailsBullet1Text: 'Any Total Interest and Total Amounts shown are estimates only.',
            termDetailsBullet2Text: 'A reduced APR will be charged on this transaction from the later of (1) the transaction date shown or (2) the first day of the billing cycle in which you choose this promotional offer, and fixed monthly payments are required until the transaction is paid in full. These payments are equal to {{percentageValue}}% of the transaction amount shown, rounded up to the next whole cent and may be higher than the payments that would be required if this transaction were not put on this promotion. During the last month(s) of the promo period the required monthly payment may be reduced due to the prior months’ rounding.',
            termDetailsBullet3Text: 'Any estimated required monthly payment shown in connection with this offer should allow you to pay off the transaction within the promo period if (1) you make your payments by the due date each month and (2) this is the only balance on your account during the promo period. If you have other balances on your account, including any other promotional balances, this monthly payment will be added to the minimum payment applicable to those balances.',
            termDetailsBullet4Text: 'Regular account terms will continue to apply non-promo transactions on your account. See your credit card agreement terms.',
            termDetailsBullet5Text: 'If a purchase (or any part of the purchase) that is subject to this promotion is returned, please call the number on your billing statement or the back of your card to request the credit be applied to this promotional balance.',
            primaryDefaultButton: 'Continue',
            primaryInstallmentsButton: 'Continue',
            primaryReviewButton: 'Accept offer',
            secondaryInstallmentsButton: 'Change selection',
            secondaryReviewButton: 'Change Selection',
            secondaryDefaultButton: 'Change Transaction',
            selectTransactionHeading: 'Select a transaction below',
            selectTransactionSubHeading: "Only 4 Synchrony Select Pay balances are allowed per account at one time and transactions in dispute aren't eligible.",
            selectTransactionBullet1Text: 'Select which eligible transaction you want to pay off with a reduced APR',
            selectTransactionBullet2Text: 'Choose the reduced APR and number of monthly payments on the next screen.',
            selectTransactionBullet3Text: 'Review your selections and accept the terms of the offer. Your Synchrony Select Pay monthly payment amount will be added into your minimum payment due.',
            transactionDisputesErrorHeading: 'The transaction you selected is not eligible for Synchrony Select Pay',
            transactionDisputesErrorSubHeading: 'The transaction you selected is currently in dispute and not eligible for Synchrony Select Pay. If you have any questions, please call the number on the back of your card.'
        },
        spendingTrends: {
            categoryLabel: {
                restaurants: 'Restaurants',
                grocery: 'Grocery',
                'health&beauty': 'Health & Beauty',
                airlines: 'Airlines',
                lodging: 'Lodging',
                gas: 'Gas',
                'bills&utilities': 'Bills & Utilities',
                entertainment: 'Entertainment',
                transportation: 'Transportation',
                contractedservices: 'Contracted Services',
                other: 'Other'
            },
            bannerText: 'See your spending trends',
            drawerHeading: 'Spending Trends',
            chartHeading: 'My Spending Trends',
            chartSubHeading: 'Here’s a snapshot of your spending',
            chartDetailTotalLabel: 'Total',
            chartDetailSpentLabel: 'Spent',
            chartDetailOverallSpendLabel: 'of overall spend',
            chartEmptyLabel: 'No purchases to show',
            totalSpentLabel: 'Total Spent',
            primaryButton: 'Back to activity',
            categoriesTableHeader: 'Categories',
            percentSpentTableHeader: 'Percent Spent',
            amountTableHeader: 'Amount Spent',
            categoriesNotShownNoticeText: 'Categories with $0 spent not shown.',
            disclaimerBoldedText: 'Note:',
            disclaimerText: 'Spending trends by category reflect posted purchases. If you earn rewards by category, those rewards categories may differ from the ones displayed in the chart above. Please refer to credit card rewards terms for specific information.'
        }
    }
};
export default en;
//# sourceMappingURL=en.js.map